function normalizeRuntime(runtime) {
  const value = String(runtime || '').trim().toLowerCase()
  // Read-only compatibility for rows created before runtime=lua became canonical.
  if (value === 'game' || value === 'game-lua') return 'lua'
  return value
}

export function resolveInstallationRuntime(installation) {
  const topLevel = normalizeRuntime(installation?.runtime)
  const entrypoint = String(installation?.entrypoint || '').trim().toLowerCase()
  const nested = normalizeRuntime(installation?.plugin?.runtime)

  // Stater's flat shape carries the canonical resolved version contract as
  // runtime+entrypoint. The plugins API uses nested plugin.runtime as its
  // resolved installation projection. A legacy top-level runtime without an
  // entrypoint is only a compatibility fallback and must not override nested.
  if (topLevel && entrypoint) return topLevel
  return nested || topLevel || 'iframe'
}

// Installation snapshots have two supported projections:
// - plugins API: { id: installationId, plugin: { id: pluginId } }
// - stater realtime: { id: installationId, plugin_id: pluginId }
// Never fall back to installation.id: that routes character links with an
// installation UUID, which cannot match the canonical character catalog.
export function resolveInstallationPluginId(installation) {
  const nested = installation?.plugin && typeof installation.plugin === 'object'
    ? installation.plugin
    : null
  return String(nested?.id || installation?.plugin_id || installation?.pluginId || '').trim()
}

export function isGameInstallation(installation) {
  return resolveInstallationRuntime(installation) === 'lua'
}
